import { FULL_ROUTES } from '@sonar-software/sonar-ts-constants';
import { useLocation } from 'react-router-dom';
export function useDataDictionaryWorkflow() {
    const { pathname } = useLocation();
    const lowerPath = pathname.toLowerCase();
    return lowerPath.startsWith(FULL_ROUTES.DATA_DICTIONARY);
}
